import PropTypes from 'prop-types';

export const contextPropTypes = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

export const contextKeys = [
  'cid',
  'aid',
  'uid',
  'campaignId',
  'pageEnum',
];

const scenarioNamePrefix = 'UnifiedNotificationQueue';
const APIScenarioNamePrefix = `${scenarioNamePrefix}API`;
const generateScenarioName = suffix => `${scenarioNamePrefix}${suffix}`;
const generateAPIScenarioName = suffix => `${APIScenarioNamePrefix}${suffix}`;

// Error scenarioName has _Error_ in the middle for not impacting metrics
export const scenarioNames = {
  InvalidContext: generateScenarioName('InvalidContext'),
  NotificationLoad: generateScenarioName('NotificationLoad'),
  NotificationLoadError: generateScenarioName('_Error_NotificationLoad'),
  NotificationDismiss: generateScenarioName('NotificationDismiss'),
  NotificationDismissError: generateScenarioName('_Error_NotificationDismiss'),
  NotificationDismissAll: generateScenarioName('NotificationDismissAll'),
  NotificationCard: generateScenarioName('NotificationCard'),
  NotificationSeverity: generateScenarioName('NotificationSeverity'),
  NotificationRender: generateScenarioName('NotificationRender'),
  PreviewBarLoad: generateScenarioName('PreviewBarLoad'),
  PreviewBarLoadError: generateScenarioName('_Error_PreviewBarLoad'),
  PreviewBarShow: generateScenarioName('PreviewBarShow'),
  PreviewBarViewMore: generateScenarioName('PreviewBarViewMore'),
  PreviewBarDismiss: generateScenarioName('PreviewBarDismiss'),
  PreviewBarRender: generateScenarioName('PreviewBarRender'),
  PreviewBarRenderNotifications: generateScenarioName('PreviewBarRenderNotifications'),
  QueueDisplayShow: generateScenarioName('QueueDisplayShow'),
  TriggerClick: generateScenarioName('TriggerClick'),
  TriggerShow: generateScenarioName('TriggerShow'),
  TriggerShowContextChanged: generateScenarioName('TriggerShowContextChanged'),
  WhatsNewLoad: generateScenarioName('WhatsNewLoad'),
  WhatsNewRender: generateScenarioName('WhatsNewRender'),
  WhatsNewDismiss: generateScenarioName('WhatsNewDismiss'),
};

export const APIScenarioNames = {
  removeExByIds: generateAPIScenarioName('RemoveExByIds'),
  removeExByIdsInternal: generateAPIScenarioName('RemoveExByIdsInternal'),
  removeAllEx: generateAPIScenarioName('RemoveAllEx'),
  removeAllExInternal: generateAPIScenarioName('RemoveAllExInternal'),
  removeEx: generateAPIScenarioName('RemoveEx'),
  removeExInternal: generateAPIScenarioName('RemoveExInternal'),
  showEx: generateAPIScenarioName('ShowEx'),
  setPreviewBarVisibility: generateAPIScenarioName('setPreviewBarVisibility'),
};

export const notificationLogKeys = [
  'severity',
  'notificationSource',
  'notificationTypeId',
  'uiDeliveryId',
  'opportunityNotification',
];

export const APINotificationLogKeys = [
  'id',
  'severity',
  'notificationSource',
  'notificationTypeId',
];

export const whatsNewId = 'whats-new';
export const whatsNewHelpQuery = 'help:app50044';
export const whatsNewHelpClass = 'HelpTopic';
export const whatsNewSeverity = 'Information';
export const whatsNewSeverityOrder = 3.5;

export const whatsNewDefaultParams = {
  project: 'bing_ads',
  language: 'en-US', // default
  asRow: -2,
  query: whatsNewHelpQuery,
};

export const severityOrder = {
  Critical: 1,
  Warning: 2,
  Opportunity: 3,
  Information: 4,
};

export const requestStates = {
  notStart: 1,
  inProgress: 2,
  loaded: 3,
};

export const previewBarStates = {
  notShown: 1,
  shouldShow: 2,
  hidden: 3,
  dismissed: 4,
};

export const previewBarDismissedValue = 'dismissed';

export const noCacheResponseRequestHeader = {
  contentType: 'application/json',
  dataType: 'json',
  cacheResponse: false,
};

export const notificationSources = {
  messageCenter: 'MessageCenter',
  adInsightOpportunity: 'AdInsightOpportunity',
  recommendation: 'Recommendation',
  whatsNew: 'WhatsNew',
};

export const actionCallbackTypes = {
  closeQueue: 'closeQueue',
  closeQueueOnAccountsSummaryPage: 'closeQueueOnAccountsSummaryPage',
  openDialog: 'openDialog',
};
